module.exports = __webpack_public_path__ + "media/images/search_empty-ccdf89f486c2ac576c2f428010d6508a.png";